import axios from "@/plugins/axios";

let url = "/api/console/cps/cashes";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
	}
}
